module.exports = __webpack_public_path__ + "static/media/rbs-ulsterbank.58238928.svg";